import React, { useState } from 'react';
import '../styles/ButtonExample.css';

const ButtonExample = () => {
  const [clickMessage, setClickMessage] = useState('');

  const handleClickMe = () => {
    setClickMessage('Button click successful! You have triggered the click action.');
  };

  return (
    <div className="button-example">
      <h2 className="button-example-heading">Click Me</h2>
      <p className="button-example-description">
        Click the button below to trigger a simple click action.
      </p>

      <button
        type="button"
        onClick={handleClickMe}
        className="click-me-button"
        id="click-me-button"
      >
        Click Me
      </button>

      {clickMessage && (
        <p className="click-message" id="click-message" role="status">
          {clickMessage}
        </p>
      )}
    </div>
  );
};

export default ButtonExample;
